import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/monitoring/sentry";
import { initPostHog } from "@/lib/monitoring/posthog";
import { getStoredConsent } from "@/components/CookieConsent";

// Initialise monitoring before React renders so the first render
// is already instrumented. Sentry is always active (anonymised errors only).
// PostHog is only initialised if the user has previously accepted analytics
// cookies. On first visit, CookieConsent banner handles initialisation after
// consent is given.
initSentry();
// Only init PostHog if the user has already accepted analytics cookies.
// On first visit, CookieConsent banner handles initialisation after consent.
if (getStoredConsent() === "accepted") {
  initPostHog();
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
